import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
//import { ToastsStore } from 'react-toasts';
//import UserUtils from "../utils/UserUtils";
//import socketIOClient from "socket.io-client";
//const ENDPOINT = "/";

const mapStateToProps = (state) => {
    return {
        reduceTasks: state.reduceTasks
    }
}

export default connect(mapStateToProps)(NotificationTask);

function NotificationTask(props) {
    const { t } = useTranslation('common');

    // useEffect(() => {
        // const user = UserUtils.getUser();
        // const socket = socketIOClient(ENDPOINT, {
        //     transports: ['websocket'],
        //     upgrade: false
        // });

        // setTimeout(function () {
        //     const data = { userId: user.uid, socketId: socket.id };
        //     socket.emit('setSocketId', data);
        // }, 5000)

        // socket.on("createtask", task => {
        //     const isUserConnected = task.assignedTo.find(u => u.uid === user.uid);
        //     if (isUserConnected) {
        //         ToastsStore.info(
        //             <div className="popup-task">
        //                 <div className="header">
        //                     <span>{`${t('TASK_031')} ${task.title}`}</span>
        //                 </div>
        //                 <div className="container">
        //                     <span className="description">{t('TASK_032')}</span>
        //                 </div>
        //             </div>);
        //     }
        // });
    // }, []);

    return (
        <></>
    )

}